import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';
import SpinCentered from '@/comp/SpinCentered';
import ImageUpload from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/Tabs/AssetImages/ImageUpload/ImageUpload';
import ImageList from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/Tabs/AssetImages/ImageList/ImageList';
import { permissions } from '@/constants';

interface UniversalAssetImagesProps {
  deviceId: string;
}

const UniversalAssetImages = observer(({ deviceId }: UniversalAssetImagesProps) => {
  const { devicesStore, imageUploadStore, permissionStore, mapBuilderStore, stationStore } = useStores();

  const device = stationStore.getDeviceById(deviceId);
  if (!device) return null;

  useEffect(() => {
    const fetchDeviceImages = async () => {
      imageUploadStore.reset();
      imageUploadStore.setDeviceId(device.deviceId);
      mapBuilderStore.setSelectedDevice(device);
      await devicesStore.getDeviceImages(device.deviceId);
      imageUploadStore.setNoEditPermission(!permissionStore.isAuth(permissions.UPDATE_DEVICE_IMAGES));
    };
    fetchDeviceImages();
    return () => mapBuilderStore.setSelectedDevice(null);
  }, [device.deviceId]);

  if (devicesStore.isLoadingDeviceImages) {
    return <SpinCentered />;
  }

  return devicesStore.deviceImages?.length > 0 ? <ImageList deviceId={device.deviceId} /> : <ImageUpload deviceId={device.deviceId} />;
});

export default UniversalAssetImages;

